module.exports = __webpack_public_path__ + "img/banner.3da19dc9.png";